export enum Roles {
  SUPER_ADMIN = 'SpAdm',
  ADMIN = 'Admin',
  AGENCY = 'Agency',
  // LEADER = "Leader",
  SPVISOR = 'SpVisor',
  OIL_MC = 'OilMc',
}

export const RolesName = {
  [Roles.SUPER_ADMIN]: 'Quản trị viên',
  [Roles.AGENCY]: 'Đại lý',
  // [Roles.LEADER]: "Trưởng nhóm",
  [Roles.SPVISOR]: 'Nhân viên đối soát',
  [Roles.ADMIN]: 'Admin',
  [Roles.OIL_MC]: 'OilMc',
};

export enum SubRolesOfAgency {
  STAFF = 'Staff',
  DRIVER = 'Driver',
  PARTNER = 'Partner',
  CUSTOMER = 'Customer',
}

export const SubRolesNameOfAgency = {
  [SubRolesOfAgency.STAFF]: 'Nhân viên',
  [SubRolesOfAgency.DRIVER]: 'Tài xế',
  [SubRolesOfAgency.PARTNER]: 'Đối tác',
  [SubRolesOfAgency.CUSTOMER]: 'Khách hàng',
};

// export enum Roles {
//   ADMIN = 'Quản trị viên',
//   AGENCY = 'Đại lý',
//   LEADER = 'Trưởng nhóm',
//   SPVISOR = 'Nhân viên đối soát',
// }
